// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N4LXp","input":"styles_input__3NDB3"};